
<template>
    <div class="positionMainContainer main-container onboarding-flow">
        <div id="myProgress">
                <div :style="{ 'width': width + '%' }" id="myBar"></div>
        </div>
        <!-- <bannerDialog
            v-if = "!showIntermediateStep && step === 5 && !showBankDetails"
            :closeBanner = "closeBanner"
            @closeDialog="closeDialog"
        /> -->
        <bankDetails  v-if="(step === 5 || step === 6 || step === 7) && showBankDetails"  @goBack="closeBankDetails" :onBoardingComponent="true"/>
        <div class = "subContainer" v-else>
            <RhsBanner
                :step="step"
                :showIntermediateStep="showIntermediateStep"
            />
            <div class="leftpanel-container">
                <div v-if="showIntermediateStep && step < 6" class="cardContainer">
                    <DetailsCard
                        :cardTitle="cardTitle"
                        :cardContent="cardContent"
                    />
                    <div class="register__form--referral-bottom">
                        <button style = "width: 310px !important" class="btn_new btn-secondary-new mt-15 mb-15" @click="showIntermediateStep = false">Continue </button>
                    </div>
                </div>
                <EmailVerification
                    v-else-if="!showIntermediateStep && step === 1"
                    @success="handleStep"
                />
                <AadhaarVerification
                    v-if="!showIntermediateStep && step === 2"
                    @success="handleStep"
                />

                <div v-if="step === 3 || step === 4 || step === 5 || step === 6 || step === 7" class="register">
                    <div v-if="step === 3 || step === 4" class="register--container">

                        <PanVerification
                            v-if="!showIntermediateStep && step === 3"
                            @success="handleStep"
                        />

                        <BankVerification
                            v-if="!showIntermediateStep && step === 4"
                            @success="handleStep"
                        />
                        </div>
                    <div v-if="step === 5 || step === 6" style = "width: 100%; margin: 0 auto; position: relative; display: flex; flex-direction: column; align-items: center">
                        <PlanSelectionNew
                            v-if="!showIntermediateStep && step === 5"
                            :isCreatePortfolio="isCreatePortfolio"
                            :isEditPortfolio="isEditPortfolio"
                            :currentPortfolio="portfolio"
                            @portfolio="portfolioHandler"
                            @success="handleStep"
                            @skipPayment="skipPayment"
                        />
                        <PaymentComponent
                            v-if="!showIntermediateStep && step === 6"
                            :isFirstTime="true"
                            :transactionPurpose="'portfolio'"
                            :showProduct="true"
                            :hideBankTransfer="false"
                            :minimumAmount="5000"
                            :queries="queries"
                            @success="handleStep"
                            @goBack="goBack"
                        />
                        </div>
                    <div
                        class="summary"
                        v-if="step === 7"
                    >
                            <div class = "eSignContainer">
                                <DetailsCard :cardTitle="getCardTitle" :cardContent="getCardContent"/>
                                <PlanCard v-if="portfolio" :portfolio="portfolio"/>
                                <Esign
                                    v-if="isEsign"
                                    @failure="eSignFailure"
                                />
                                <div class="register__form--referral-bottom">
                                    <small>Once you click on Sign Agreement, you will be redirected to another portal to digitally sign the agreement using mobile OTP. </small>
                                    <div style="display: flex; justify-content: center; align-items: center">
                                        <button class="eSignButton btn_new btn-secondary-new mt-15 mb-15" :disabled="disabled" @click="continueToESign">Proceed To Sign</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div  v-if="step != 6" class = "RbiText">RBI Licensed NBFC P2P - COR No: N.13-02409</div>
        <div class="footerText">Copyright 2022: Trickle Flood Technologies Pvt Ltd, All Rights Reserved</div>
        <v-snackbar
            v-model="isFailure"
            app
            timeout="3000"
        >
                {{failureText}}

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isFailure = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import EmailVerification from '@/components/lenderOnboarding/emailVerification'
import PanVerification from '@/components/lenderOnboarding/panVerification'
import AadhaarVerification from '@/components/lenderOnboarding/aadhaarVerification'
import BankVerification from '@/components/lenderOnboarding/bankVerification'
import PlanSelectionNew from '@/components/lenderOnboarding/planSelectionNew'
import RhsBanner from '../components/common/right-side-banner/rhs-banner.vue'
import PlanCard from '@/components/common/planCard/planCard.vue'
import DetailsCard from '@/components/common/detailsCard/detailsCard.vue'
import Esign from '@/components/lenderOnboarding/eSign'
import PaymentComponent from '@/components/common/paymentComponent/paymentComponent.vue'
import onboardingService from '@/services/lenderOnboardingService'
// import bannerDialog from '@/components/common/bannerDialog.vue'
import bankDetails from '@/components/bankAccountDetails/BankAccountDetails.vue'

export default {
    name: 'LenderOnboarding',
    components: {
        PlanSelectionNew,
        EmailVerification,
        PanVerification,
        AadhaarVerification,
        BankVerification,
        PlanCard,
        PaymentComponent,
        Esign,
        RhsBanner,
        DetailsCard,
        // bannerDialog,
        bankDetails
    },
    data () {
        return {
            width: 13,
            step: 1,
            portfolio: null,
            cardTitle: null,
            showIntermediateStep: false,
            cardContent: [],
            isCreatePortfolio: true,
            isEditPortfolio: false,
            isEsign: false,
            isFailure: false,
            failureText: 'Please try again!',
            queries: null,
            disabled: false,
            closeBanner: true
        }
    },
    beforeRouteLeave (to, from, next) {
        if (to.path === '/dashboard' || to.path === 'onboarding') {
            next()
        } else {
            // TODO change prompt message
            if (!window.confirm(`You will be redirected to ${to.name}`)) {
                window.history.forward()
                return
            }
            this.$store.dispatch('logout')
            next()
        }
    },
    created () {
        this.queries = this.$route.query
        this.step = parseInt(this.$store.state.onBoarding.step)
        this.width = 13 * this.step
        this.showIntermediateStep = this.$store.state.onBoarding.showIntermediateStep
        if (this.showIntermediateStep) {
            this.getCardDetails()
        }
        this.$store.dispatch('onBoarding/setField', { field: 'showIntermediateStep', value: true })

        // if (this.step === 6) {
        //     this.step--
        //     this.$store.dispatch('onBoarding/decrementStep')
        // }
        if (this.step >= 5) {
            this.checkEsign()
        }
        if (this.step >= 6) {
            this.showIntermediateStep = false
        }
    },
    computed: {
        getCardTitle () {
            return this.$store.state.onBoarding.Name
        },
        getCardContent () {
            return this.$store.getters['onBoarding/getCardDetails']
        },
        showBankDetails () {
            return this.$store.state.onBoarding.showBankDetails
        }
    },
    methods: {
        closeDialog () {
            this.closeBanner = false
        },
        continueToESign () {
            this.disabled = true
            setTimeout(() => {
                this.disabled = false
            }, 5000)
            if (this.isEsign) {
                this.isEsign = false
                setTimeout(() => {
                    this.isEsign = true
                }, 500)
            } else {
                this.isEsign = true
            }
        },
        routeToRegister () {
            localStorage.clear('token')
            this.$router.push('/register')
        },
        handleStep () {
            this.step++
            this.width = 13 * this.step
            this.$store.dispatch('onBoarding/incrementStep')
            if (this.step >= 5) {
                this.checkEsign()
            }
        },
        skipPayment () {
            this.step += 2
            this.width = 13 * this.step
            this.$store.dispatch('onBoarding/setStep', this.step)
            if (this.step >= 5) {
                this.checkEsign()
            }
        },
        async checkEsign () {
            this.$store.commit('isLoading')
            const eSign = await onboardingService.checkESign()
            if (eSign.status === 200) {
                this.$store.dispatch('dashboard/setField', { field: 'isLenderContractSigned', value: true })
                this.$store.dispatch('dashboard/setField', { field: 'generatedReferralCode', value: eSign.data.generatedReferralCode })
                this.$router.push('/dashboard')
            } else if (eSign.status === 207) {
            }
            this.$store.commit('isNotLoading')
        },
        eSignFailure () {
            this.isEsign = false
            this.isFailure = true
            this.failureText = 'Signing failed. Please try again!'
        },
        goBack () {
            this.width -= 13
            this.step--
            if (this.step === 5 && this.portfolio) {
                this.isCreatePortfolio = false
                this.isEditPortfolio = true
            }
            this.$store.dispatch('onBoarding/decrementStep')
        },
        getCardDetails () {
            this.cardContent = this.$store.getters['onBoarding/getCardDetails']
            this.cardTitle = this.$store.state.onBoarding.Name
        },
        portfolioHandler (data) {
            this.$store.commit('portfolio/setPortfolio', data)
            this.portfolio = data
        },
        closeBankDetails () {
            this.$store.dispatch('onBoarding/setField', { field: 'showBankDetails', value: false })
            window.location.reload()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";
@import "~@/sass/components/registration-flow.scss";
@import "./stepper.scss";

.eSignButton {
}
.cardContainer {
    padding-top: 80px;
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
        width: 240px;
    }
}

.summary {
    padding-top: 30px;
    width: 100%;
    margin: 0 auto;
    position: relative;
}

@media (max-width: 990px) {
    .cardContainer {
        width: 80%;
        margin-top: 50px;
    }
    .eSignContainer {
    padding-left: 30px !important;
    padding-right: 30px !important;
    padding-top: 20px !important
    }
    .subContainer {
        display: flex !important;
        flex-direction: column-reverse !important
    }
    .summary {
        padding-top: 10px;
        width: 100%;
        margin: 0 auto;
        position: relative;
    }
}
#myProgress {
    z-index: 1;
    position: absolute;
    width: 100%;
    background-color: #e0e0e0;
}

#myBar {
  border-top-right-radius: 60px;
  border-bottom-right-radius: 60px;
  width: 80%;
  height: 30px;
  background-color: #002fa7;
  text-align: center;
  line-height: 4px;
  color: white;
  max-height: 3px
}
.eSignContainer {
    padding-left: 150px;
    padding-right: 150px;
}
.positionMainContainer {
    display: flex !important;
    flex-direction: column !important;
    min-height: 100% !important;
    position: relative !important;
}
.subContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%
}
.footerText {
    text-align: center;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    font-size: 12px;
}
.RbiText {
    text-align: center;
    color: #000000;
    font-weight: 600
}
</style>
